module.exports = __webpack_public_path__ + "bq.svg?559038bc1b2e0b64bf6190bdbd4b41bb";